// extracted by mini-css-extract-plugin
export default {"messageModalWindow":"DefaultAccessPointDictionaryCommandsPanel_messageModalWindow__Kqjc9"};